import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { MessageSquare, X } from 'lucide-react';
import { API } from '@/config/api';
export default function FeedbackWidget() {
  const dialog = useRef(null);
  const sending = useRef(false);
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState(null);
  useEffect(() => { if (open) dialog.current?.showModal(); else dialog.current?.close(); }, [open]);
  async function submit(event) {
    event.preventDefault();
    if (sending.current || message.trim().length < 10) return;
    sending.current = true; setBusy(true); setStatus(null);
    try {
      const response = await axios.post(API + '/contact/send', {
        subject: 'Other', email: email.trim(), honeypot: event.currentTarget.elements.website.value,
        message: '[Website suggestion]\nPage: ' + window.location.pathname + '\n\n' + message.trim()
      }, { timeout: 20000 });
      if (response.data?.status !== 'success') throw new Error('Submission failed');
      setMessage(''); setStatus({ ok: true, text: 'Thank you. Your suggestion has been received.' });
    } catch (error) {
      setStatus({ ok: false, text: error.response?.status === 429 ? 'Too many messages. Please try again later.' : 'We could not send your suggestion. Please try again.' });
    } finally { sending.current = false; setBusy(false); }
  }
  return <>
    <button type="button" onClick={() => setOpen(true)} aria-haspopup="dialog" className="fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-amber-400 px-4 py-3 font-semibold text-gray-950 shadow-lg hover:bg-amber-300">
      <MessageSquare size={20} aria-hidden="true" /><span>Suggest an improvement</span>
    </button>
    <dialog ref={dialog} onCancel={() => setOpen(false)} onClose={() => setOpen(false)} aria-labelledby="feedback-title" className="m-auto w-[calc(100%-2rem)] max-w-md max-h-[85vh] overflow-y-auto rounded-2xl border border-gray-700 bg-gray-900 p-6 text-white shadow-xl backdrop:bg-black/70">
      <div className="mb-3 flex items-center justify-between gap-3">
        <h2 id="feedback-title" className="text-xl font-semibold">Suggest an improvement</h2>
        <button type="button" aria-label="Close feedback" onClick={() => setOpen(false)} className="rounded p-2 hover:bg-gray-800"><X size={20} /></button>
      </div>
      <p className="mb-4 text-sm text-gray-300">What would make Lotterics more useful to you?</p>
      <form onSubmit={submit} className="space-y-4">
        <label className="block text-sm">Your email<input type="email" required maxLength={254} autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} className="mt-1 w-full rounded border border-gray-600 bg-gray-950 p-3" /></label>
        <label className="block text-sm">Your suggestion<textarea required minLength={10} maxLength={3000} rows={4} value={message} onChange={e => setMessage(e.target.value)} className="mt-1 w-full rounded border border-gray-600 bg-gray-950 p-3" /></label>
        <input type="text" name="website" aria-hidden="true" tabIndex={-1} autoComplete="off" className="hidden" />
        <p className="text-xs text-gray-400">The current page path is included with your suggestion.</p>
        {status && <p role={status.ok ? 'status' : 'alert'} className={status.ok ? 'text-green-400 text-sm' : 'text-red-400 text-sm'}>{status.text}</p>}
        <button type="submit" disabled={busy || message.trim().length < 10} className="w-full rounded bg-amber-400 px-4 py-3 font-semibold text-gray-950 hover:bg-amber-300 disabled:opacity-50">{busy ? 'Sending...' : 'Send suggestion'}</button>
      </form>
    </dialog>
  </>;
}
